import { RouteObject, useNavigate } from "react-router";

import { Button, ButtonStyle, PageHeading } from "@prequel/shared-components";

import DestinationActivitiesTable from "./DestinationActivitiesTable";
import DestinationAdmin from "./DestinationAdmin";
import DestinationConnectionDetails from "./DestinationConnectionDetails";
import DestinationDetails from "./DestinationDetails";
import DestinationForm from "./DestinationForm";
import DestinationPage, { DestinationEditWrapper, DestinationPageWrapper } from "./DestinationPage";
import DestinationsTable from "./DestinationsTable";
import IntegrityJobDetails from "./IntegrityJobDetails";
import TransferDetails from "./TransferDetails";

import Breadcrumbs from "@/components/Breadcrumbs";

const DestinationsListLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-6xl px-7 py-4 pb-16">
        <PageHeading title="Destinations">
          <Button text="Add Destination" onClick={() => navigate("/destinations/new")} type={ButtonStyle.SECONDARY} />
        </PageHeading>
        <DestinationsTable />
      </div>
    </div>
  );
};

const DestinationFormLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-xl px-7 py-4">
        <PageHeading title="Add Destination" onGoBack={() => navigate("/destinations")} breadcrumbs={<Breadcrumbs />} />
        <DestinationForm />
      </div>
    </div>
  );
};

export const destinationsRoutes: RouteObject = {
  path: "destinations",
  handle: {
    breadcrumb: () => ({ label: "Destinations" }),
  },
  children: [
    {
      index: true,
      element: <DestinationsListLayout />,
    },
    {
      path: "new",
      handle: {
        breadcrumb: () => ({ label: "Add Destination" }),
      },
      element: <DestinationFormLayout />,
    },
    {
      path: ":destinationID",
      handle: {
        breadcrumb: () => ({
          label: "Destination Details",
          dynamic: true,
        }),
      },
      element: <DestinationPage />,
      children: [
        {
          element: <DestinationPageWrapper />,
          children: [
            {
              index: true,
              element: <DestinationActivitiesTable />,
            },
            {
              path: "details",
              element: <DestinationDetails />,
            },
            {
              path: "connection",
              element: <DestinationConnectionDetails />,
            },
            {
              path: "admin",
              element: <DestinationAdmin />,
            },
          ],
        },
        {
          path: "edit",
          handle: {
            breadcrumb: () => ({
              label: "Edit Destination",
            }),
          },
          element: <DestinationEditWrapper />,
          children: [
            {
              index: true,
              element: <DestinationForm />,
            },
          ],
        },
        {
          path: "transfers/:transferID",
          handle: {
            breadcrumb: () => ({
              label: "Transfer Details",
            }),
          },
          element: <TransferDetails />,
        },
        {
          path: "integrity/:integrityID",
          handle: {
            breadcrumb: () => ({
              label: "Integrity Job Details",
            }),
          },
          element: <IntegrityJobDetails />,
        },
      ],
    },
  ],
};
